module.exports = __webpack_public_path__ + "static/assets/5fdb7c093bfefc2c00ef83fd4c34199e.gif";